module.exports = __webpack_public_path__ + "img/instagram.98fa8074.svg";